// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#salepage-editor *[contentEditable=\"true\"]:focus,\n#salepage-editor *[contentEditable=\"true\"]:hover {\n  outline: 2px solid #2276d2;\n}\n.stock-input-style .v-select {\n  max-width: 400px;\n}\n", ""]);
// Exports
module.exports = exports;
